/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AdminOfferDto = {
    id: string;
    internalName: string;
    tag: string;
    heading: string;
    subheading: string;
    details: string;
    /**
     * Targeted dial codes
     */
    marketCodes: Array<string>;
    showOnHome: boolean;
    showOnDiscover: boolean;
    showOnProfile: boolean;
    showOnCheckout: boolean;
    showOnSignupPrompt: boolean;
    showToGuests: boolean;
    /**
     * First day, UAE time (YYYY-MM-DD)
     */
    startDate: string;
    /**
     * Last day, inclusive, UAE time (YYYY-MM-DD)
     */
    lastDay: string;
    /**
     * Pause switch
     */
    isActive: boolean;
    /**
     * Derived on read, in this precedence: ended (past its last day), paused, scheduled (before its first day), live
     */
    status: AdminOfferDto.status;
    createdAt: string;
    updatedAt: string;
};
export namespace AdminOfferDto {
    /**
     * Derived on read, in this precedence: ended (past its last day), paused, scheduled (before its first day), live
     */
    export enum status {
        SCHEDULED = 'scheduled',
        LIVE = 'live',
        PAUSED = 'paused',
        ENDED = 'ended',
    }
}

